import { axios } from 'utils/axios';

const calculateInertization = (data) => {
    return axios.post('/safetypro/calculator/inertization', data);
};

const calculateVentilation = (data) => {
    return axios.post('/safetypro/calculator/ventilation', data);
};

export {
    calculateInertization,
    calculateVentilation,
};
